import React from "react";

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  fullWidth?: boolean;
  variant?: "contained" | "outlined" | "text";
  size?: "xs" | "sm" | "md" | "lg";
  color?:
    | "primary"
    | "secondary"
    | "error"
    | "warning"
    | "info"
    | "success"
    | "white";
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  fullWidth,
  variant = "contained",
  size = "md",
  color = "primary",
}) => {
  return (
    <button
      className={`font-medium rounded-md p-2  transition-all duration-300 ${
        variant === "contained"
          ? color === "primary"
            ? "bg-black text-white hover:bg-black/80"
            : color === "secondary"
            ? "bg-white text-black hover:bg-gray-100"
            : color === "error"
            ? "bg-red-500 text-white hover:bg-red-600"
            : color === "warning"
            ? "bg-yellow-500 text-white hover:bg-yellow-600"
            : color === "info"
            ? "bg-blue-500 text-white hover:bg-blue-600"
            : color === "success"
            ? "bg-green-500 text-white hover:bg-green-600"
            : color === "white"
            ? "bg-white text-black"
            : "bg-black text-white hover:bg-black/80"
          : variant === "outlined"
          ? "bg-white border border-gray-300 text-black hover:bg-gray-100"
          : "bg-transparent text-black hover:bg-gray-100"
      } ${fullWidth ? "w-full" : "w-fit"} ${
        size === "xs"
          ? "p-1 text-xs"
          : size === "sm"
          ? "p-2 text-sm"
          : size === "md"
          ? "p-3 text-base"
          : "p-4 text-lg"
      }`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
